<form class="chart-create-form" (ngSubmit)="submit()">
  <label class="ccf-label" for="chart-create-name">
    {{ text().nameLabel }}
  </label>
  <input
    id="chart-create-name"
    class="form-control"
    type="text"
    [value]="name()"
    (input)="name.set($any($event.target).value)"
    [placeholder]="text().namePlaceholder"
    [attr.aria-label]="text().nameAria"
  />

  @if (renameOnly()) {
    <!-- Cycle/composite: herberekenen zou het document door een natal chart vervangen. -->
    <p class="ccf-rename-only-hint">{{ text().renameOnlyHint }}</p>
  } @else {
    <label class="ccf-label">{{ text().birthDateLabel }}</label>
    <hd-birth-date-input [initialDate]="initial()?.date" (valueChange)="onDateChange($event)" />

    <label class="ccf-label">{{ text().birthTimeLabel }}</label>
    <hd-birth-time-input
      [initialTime]="initial()?.time?.time ?? '12:00'"
      [initialIsUtc]="initial()?.time?.isUtc ?? false"
      (valueChange)="onTimeChange($event)"
    />

    <label class="ccf-label">
      {{ text().locationLabel }}
      @if (timeValue().isUtc) {
        <span class="ccf-label-hint">{{ text().locationOptionalHint }}</span>
      }
    </label>
    <hd-location-picker [initialLocation]="initial()?.location ?? null" (locationChange)="onLocationChange($event)" />

    @if (initial()) {
      <label class="ccf-recalc" [class.is-disabled]="birthChanged()">
        <input
          type="checkbox"
          class="ccf-recalc-check"
          [checked]="birthChanged() || forceRecalculate()"
          [disabled]="birthChanged()"
          (change)="onForceRecalculateChange($any($event.target).checked)"
        />
        {{ text().recalculate }}
      </label>
    }
  }

  @if (error(); as message) {
    <p class="ccf-error" role="alert">{{ message }}</p>
  }

  @if (!initial()) {
    @if (calculateOnlyOffered()) {
      <!-- Default slaat de pagina de berekende chart meteen op; dit vinkje geeft
           het oude gedrag (onopgeslagen tab met sterretje). -->
      <label class="ccf-calc-only">
        <input
          type="checkbox"
          class="ccf-calc-only-check"
          [checked]="calculateOnly()"
          (change)="calculateOnly.set($any($event.target).checked)"
        />
        {{ text().calculateOnlyLabel }}
      </label>
    }

    @if (markAsMyChartOffered() && !calculateOnly()) {
      <!-- Enkel zolang er nog geen "mijn chart" is (eerste eigen chart);
           standaard aan. Vervalt bij "enkel berekenen" (niets om te markeren). -->
      <label class="ccf-my-chart">
        <input
          type="checkbox"
          class="ccf-my-chart-check"
          [checked]="markAsMyChart()"
          (change)="markAsMyChart.set($any($event.target).checked)"
        />
        {{ text().markAsMyChartLabel }}
      </label>
    }
  }

  <div class="ccf-actions">
    <button eBtn type="button" color="highlight" (click)="cancelled.emit()">
      {{ text().cancel }}
    </button>
    <button eBtn type="submit" color="primary-75" icon="check" [disabled]="!canSubmit">
      {{ loading() ? text().calculating : text().submit }}
    </button>
  </div>
</form>
